function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { px2rem, getSpacing, getDisplay } from '../../utils/helpers';
var GridWrapper = styled.div(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme,
      background = _ref.background;
  var breakpoints = theme.breakpoints,
      grid = theme.grid,
      colors = theme.colors;
  var security = grid.security,
      gutters = grid.gutters;

  var getProperties = function getProperties(bpKey) {
    return {
      paddingRight: typeof security[bpKey] === 'number' ? px2rem(gutters / 2 + security[bpKey]) : "calc(" + px2rem(gutters / 2) + " + " + security[bpKey] + ")",
      paddingLeft: typeof security[bpKey] === 'number' ? px2rem(gutters / 2 + security[bpKey]) : "calc(" + px2rem(gutters / 2) + " + " + security[bpKey] + ")"
    };
  };

  return _extends({
    backgroundColor: colors[background],
    margin: '0 auto',
    width: '100%',
    maxWidth: px2rem(breakpoints.xxlarge)
  }, getProperties('xsmall'), (_extends2 = {}, _extends2["@media (min-width: " + breakpoints.small + "px)"] = _extends({}, getProperties('small')), _extends2["@media (min-width: " + breakpoints.medium + "px)"] = _extends({}, getProperties('medium')), _extends2["@media (min-width: " + breakpoints.large + "px)"] = _extends({}, getProperties('large')), _extends2["@media (min-width: " + breakpoints.xlarge + "px)"] = _extends({}, getProperties('xlarge')), _extends2["@media (min-width: " + breakpoints.xxlarge + "px)"] = _extends({}, getProperties('xxlarge')), _extends2));
}, getSpacing, getDisplay);
export default GridWrapper;